import React from "react";
import "./Carousel.css";

export const CarouselItem = ({ item, width }) => {
  return (
    <div className="carousel-item" style={{ width: width }}>
      <div></div>
      <img className="carousel-img" src={item.icon} alt="hello" />
      <div className="carousel-item-text-engineering">
        <div className="carousel-item-text">{item.description}</div>
      </div>
    </div>
  );
};

export default CarouselItem;
